import { useEffect } from "react";
import { motion } from "framer-motion";
import Starfield from "@/components/Starfield";
import Wordmark from "@/components/Wordmark";
import { PrimaryCTA } from "@/components/CosmicButton";

const EASE = [0.16, 1, 0.3, 1];

export default function Intro() {
    useEffect(() => {
        document.title = "Before we start | WHY THE FUCK DO I DO THAT?";
    }, []);
    return (
        <main className="relative min-h-dvh overflow-hidden bg-ink text-slate-200">
            <Starfield density={45} />
            <div className="relative z-10 mx-auto flex min-h-dvh w-full max-w-xl flex-col justify-between px-6 py-8">
                <Wordmark />

                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: EASE }}
                    className="py-14"
                >
                    <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-celestial-blue">
                        Before we start
                    </p>
                    <h1 className="mt-6 font-sans text-[clamp(2.1rem,8.5vw,3.4rem)] font-bold uppercase leading-[1.02] tracking-tight">
                        NO GENERIC PERSONALITY TEST{" "}
                        <em className="font-display normal-case italic text-celestial-gold">
                            bullshit.
                        </em>
                    </h1>
                    <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-slate-300">
                        <p>I'm not trying to tell you who you are.</p>
                        <p>
                            I'm looking at what you DO when something hits a
                            nerve.
                        </p>
                        <p className="text-slate-400">
                            Pick the answer that sounds most like your first
                            instinct — not the answer you wish you picked.
                        </p>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.25, duration: 0.7, ease: EASE }}
                >
                    <PrimaryCTA to="/quiz" testid="intro-cta-lets-do-this">
                        Let's do this
                    </PrimaryCTA>
                    <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">
                        5 situations · first instinct wins
                    </p>
                </motion.div>
            </div>
        </main>
    );
}
